/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_Counter_MarketCounter_response } from '../models/Gsoa_Counter_MarketCounter_response';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaCounterService {
    /**
     * @returns void
     * @throws ApiError
     */
    public static getApiVGsoaCounterIsAlive({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/counter/isAlive',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
    /**
     * Get actual market counter and market configuration
     * @returns Gsoa_Counter_MarketCounter_response Returns actual market counter and market configuration
     * @throws ApiError
     */
    public static getMarketCounter({
        houseNumber,
        apiVersion = 1,
    }: {
        houseNumber: number,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Counter_MarketCounter_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/counter/market/{houseNumber}',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
            },
        });
    }
}
